import { Injectable, ApplicationRef, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { SwUpdate } from '@angular/service-worker';
import { Router, NavigationEnd } from '@angular/router';
import { interval } from 'rxjs';
import { first, filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SwupdateService {
  private updateAvailable = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    appRef: ApplicationRef, 
    private updates: SwUpdate,
    private router: Router
  ) {
    // Only run in browser, not on server
    if (!isPlatformBrowser(this.platformId)) {
      // console.log('⏭Skipping SW update service (running on server)');
      return;
    }

    // console.log('🔧 SwUpdate enabled:', updates.isEnabled);

    // Wait for app to stabilize
    appRef.isStable.pipe(
      first(isStable => isStable === true)
    ).subscribe(() => {
      // console.log('App is stable, setting up SW update checks');
      
      this.setupVersionUpdateListener();
      this.setupPeriodicUpdateChecks();
    });
  }

  private setupVersionUpdateListener() {
    this.updates.versionUpdates.subscribe(event => {
      if (event.type === 'VERSION_READY') {
        // console.log('New version detected and ready');
        // console.log('Current:', event.currentVersion);
        // console.log('Latest:', event.latestVersion);
        // console.log('Will update on next navigation...');

        this.updateAvailable = true;
        this.waitForNavigationAndUpdate();
      }
      
      // if (event.type === 'VERSION_DETECTED') {
      //   console.log('🔍 New version detected, downloading...');
      // }
      
      // if (event.type === 'VERSION_INSTALLATION_FAILED') {
      //   console.error('Version installation failed:', event);
      // }
    });
  }

  private setupPeriodicUpdateChecks() {
    // Check for updates every 30 minutes
    const checkInterval = 30 * 60 * 1000; // 30 minutes
    // Check for updates every 10 seconds (for testing)
    // const checkInterval = 10 * 1000; // 10 seconds for testing

    // console.log(`Setting up update checks every ${checkInterval / 1000 / 60} minutes`);
    
    interval(checkInterval).subscribe(() => {
      if (!this.updateAvailable) {
        // console.log('Checking for updates at:', new Date().toISOString());
        this.updates.checkForUpdate().then(found => {
          // console.log('   Update check result:', found ? 'Update found' : 'No updates');
        }).catch(err => {
          // console.error('   Update check failed:', err);
        });
      }
    });
  }

  private waitForNavigationAndUpdate() {
    // Wait for the next navigation, then update
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      first()
    ).subscribe(() => {
      // console.log('Navigation detected, applying update now...');
      this.applyUpdate();
    });
  }

  private applyUpdate() {
    this.updates.activateUpdate().then(() => {
      // console.log('Update activated, reloading...');
      window.location.reload();
    }).catch(err => {
      // console.error('Failed to activate update:', err);
    });
  }
}